import type { MeResponse } from "../shared/types";

export const S: {
  me: MeResponse | null;
  route: string;
  photoBust: string;
  signin: { step: "email" | "code"; email: string };
} = {
  me: null,
  route: "home",
  photoBust: "",
  signin: { step: "email", email: "" },
};

type Handler = (el: HTMLElement, ev: Event) => unknown;
export const actions: Record<string, Handler> = {};
/** Registers handlers for elements with data-act / data-change / data-input = name. */
export const on = (map: Record<string, Handler>) => Object.assign(actions, map);

let renderer: () => void = () => {};
export const setRenderer = (f: () => void) => (renderer = f);
export const render = () => renderer();

export const isStaff = () => !!S.me?.staff;
export const isAdmin = () => !!S.me?.admin;
export const isAmbassador = () => !!(S.me?.user.roles.pa || S.me?.user.roles.sa);
